import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import TestimoniesView from './components/views/Testimonies.vue'
import TestimonyView from './components/views/Testimony.vue'
import TestimonyHistoryView from './components/views/TestimonyHistory.vue'
import CasesView from './components/views/Cases.vue'
import CaseView from './components/views/Case.vue'
import UsersView from './components/views/Users.vue'
import PasswordView from './components/views/Password.vue'
import Subscription from './components/views/Subscriptions.vue'
import Worldmap from './components/views/Worldmap.vue'

// Routes
const routes = [{
  path: '/login',
  component: LoginView,
  name: 'Login'
}, {
  path: '/',
  component: DashView,
  children: [
    {
      path: 'dashboard',
      alias: '',
      component: DashboardView,
      name: 'Dashboard',
      meta: {
        description: 'Overview of environment',
        requiresAuth: true
      }
    }, {
      path: 'worldmap',
      component: Worldmap,
      name: 'Worldmap',
      meta: {
        description: 'Worldmap testimonies location',
        requiresAuth: true
      }
    }, {
      path: 'testimonies',
      component: TestimoniesView,
      name: 'Testimonies',
      meta: {
        description: 'Testimonies management',
        requiresAuth: true
      }
    }, {
      path: 'testimonies/:id',
      component: TestimonyView,
      name: 'Testimony',
      meta: {
        description: 'Detail of a testimony',
        requiresAuth: true,
        parentName: 'Testimonies'
      }
    }, {
      path: 'testimonies/:id/history',
      component: TestimonyHistoryView,
      name: 'TestimonyHistory',
      meta: {
        description: 'History of testimony',
        requiresAuth: true,
        parentName: 'Testimonies'
      }
    }, {
      path: 'cases',
      component: CasesView,
      name: 'Cases',
      meta: {
        description: 'Cases management',
        requiresAuth: true
      }
    }, {
      path: 'cases/:id',
      component: CaseView,
      name: 'Case',
      meta: {
        description: 'Detail of a case',
        requiresAuth: true,
        parentName: 'Cases'
      }
    }, {
      path: 'users',
      component: UsersView,
      name: 'Users',
      meta: {
        description: 'Users management',
        requiresAuth: true
      }
    }, {
      path: 'users/:id/password',
      component: PasswordView,
      name: 'Password',
      meta: {
        description: 'Password management',
        requiresAuth: false
      }
    }, {
      path: 'subscriptions',
      component: Subscription,
      name: 'Subscriptions',
      meta: {
        description: 'Subscription management',
        requiresAuth: true
      }
    }
  ]
}, {
  // not found handler
  path: '*',
  component: NotFoundView
}]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js